import { combineReducers } from '@reduxjs/toolkit';
import { inPersonEventInitialState, inPersonEventReducer } from './inPersonEvent';
import { configInitialState, configReducer } from './config';
import { sessionInitialState, sessionReducer } from './session';
import * as types from '../types';
import { series3UpgradeShopInitialState, series3UpgradeShopReducer } from './series3UpgradeShop';
import { storeShopInitialState, storeShopReducer } from './storeShop';
import { subscriptionShopInitialState, subscriptionShopReducer } from './subscriptionShop';
import { tenancyInitialState, tenancyReducer } from './tenancy';
import { verizonShopInitialState, verizonShopReducer } from './verizonShop';

export const initialAppState: types.AppState = {
  ...configInitialState,
  ...series3UpgradeShopInitialState,
  ...verizonShopInitialState,
  ...sessionInitialState,
  ...storeShopInitialState,
  ...subscriptionShopInitialState,
  ...inPersonEventInitialState,
  ...tenancyInitialState,
};

const rootReducer = combineReducers<types.AppState>({
  config: configReducer,
  subscriptionShop: subscriptionShopReducer,
  series3UpgradeShop: series3UpgradeShopReducer,
  verizonShop: verizonShopReducer,
  session: sessionReducer,
  storeShop: storeShopReducer,
  inPersonEvent: inPersonEventReducer,
  tenancy: tenancyReducer,
});

export default rootReducer;
